import Table from "react-bootstrap/Table";

function RouteTable() {
  return (
    <>
      <div className="padding-spacing">
        <Table striped bordered hover>
          <thead class>
            <tr>
              <th>Distance</th>
              <th>Checkpoint</th>
              <th>Location</th>
              <th>Postcode</th>
              <th>What3Words</th>
              <th>Cut off time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0M</td>
              <td>START</td>
              <td>New Era Community Boxing</td>
              <td>CW9 5JN</td>
              <td>///clouds.lakes.valley</td>
            </tr>
            <tr>
              <td>14M</td>
              <td>CHECKPOINT 1</td>
              <td>Preston Brook</td>
              <td>WA4 4JY</td>
              <td>///explains.etchings.bought</td>
              <td>11:35am Saturday 20th Sept</td>
            </tr>
            <tr>
              <td>30M</td>
              <td>CHECKPOINT 2</td>
              <td>Bridgewater Way - Kickback Coffee</td>
              <td>WA14 5P2</td>
              <td>///admire.rarely.shell</td>
              <td>16:25pm Saturday 20th Sept</td>
            </tr>
            <tr>
              <td>45M</td>
              <td>CHECKPOINT 3</td>
              <td>Peak Forest Canal - Bridge View Cafe</td>
              <td>OL7 0QA </td>
              <td>///homes.visa.tigers</td>
              <td>21:45pm Saturday 20th Sept</td>
            </tr>
            <tr>
              <td>
                54M
              </td>
              <td>CHECKPOINT 4</td>
              <td>Marple Junction - Brabyns Park Recreational Centre</td>
              <td>SK6 5LB</td>
              <td>///figure.confining.confident</td>
              <td>01:24am Sunday 21st Sept</td>
            </tr>
            <tr>
              <td>
                65M
              </td>
              <td>CHECKPOINT 5</td>
              <td>Macclesfield Canal - Puss In Boots Pub</td>
              <td>SK10 1NF</td>
              <td>///breed.chin.dimes</td>
              <td>04:45am Sunday 21st Sept</td>
            </tr>
            <tr>
              <td>
                71.2M
              </td>
              <td>CHECKPOINT 6</td>
              <td>Bosley Locks</td>
              <td>CW12 2PD</td>
              <td>///vibrating.rocks.pushover</td>
              <td>10:30am Sunday 21st Sept</td>
            </tr>
            <tr>
              <td>
                88M
              </td>
              <td>CHECKPOINT 7</td>
              <td>Wheelock</td>
              <td>CW11 3RL</td>
              <td>///smarter.musically.requires</td>
              <td>12:48am Sunday 21st Sept</td>
            </tr>
            <tr>
              <td>
                100M
              </td>
              <td>FINISH</td>
              <td>The Broken Cross Pub - Northwich</td>
              <td>CW9 7EB</td>
              <td>///image.comic.voice</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default RouteTable;
